export default "__VITE_ASSET__CaP18VVu__"